import { hasBeenDismissed } from './hasBeenDismissed';
import { isLive } from './isLive';
import { shouldNotShowOnCurrentPage } from './shouldNotShowOnCurrentPage';
import { shouldShowOnCurrentPage } from './shouldShowOnCurrentPage';

import type { PagePopupQueueProps } from '@/components/PagePopupQueue';

interface GetNextInQueueParams {
  items: PagePopupQueueProps['items'];
  pathname: string;
}

export const getNextInQueue = ({
  items,
  pathname,
}: GetNextInQueueParams): number => {
  if (!items || items.length === 0) {
    return -1;
  }

  return items.findIndex(
    (item) =>
      isLive(item.duration) &&
      shouldShowOnCurrentPage({
        pathname,
        popupIncludeSlugs: item.includeSlugs,
      }) &&
      !shouldNotShowOnCurrentPage({
        pathname,
        popupExcludeSlugs: item.excludeSlugs,
      }) &&
      !hasBeenDismissed({
        storageKey: item.storageKey,
        storageType: item.storageType,
        forceShow: item.forceShow,
      }) &&
      !item.isHidden
  );
};
